import { createGlobalStyle } from 'styled-components'

export const CommandKBarStyles = createGlobalStyle`
  .cmdk-vercel {
    [cmdk-root] {
      max-width: 640px;
      width: 100%;
      padding: 8px;
      background: #ffffff;
      border-radius: 12px;
      overflow: hidden;
      box-shadow: 0 16px 70px rgb(0 0 0 / 20%);
      transition: transform 100ms ease;
    }

    [cmdk-input] {
      border: none;
      width: 100%;
      font-size: 17px;
      padding: 8px 8px 16px 8px;
      outline: none;
      background: ${({ theme }) => theme.colour.neutral.white};
      color: ${({ theme }) => theme.colour.secondary.base};
      border-bottom: 1px solid ${({ theme }) => theme.colour.neutral.border};
      margin-bottom: 16px;
      border-radius: 0;

      &::placeholder {
        color: ${({ theme }) => theme.colour.secondary._400};
      }
    }

    [cmdk-vercel-badge] {
      height: 20px;
      background: ${({ theme }) => theme.colour.secondary._50};
      display: inline-flex;
      align-items: center;
      padding: 0 8px;
      font-size: 12px;
      color: ${({ theme }) => theme.colour.secondary._500};
      border-radius: ${({ theme }) => theme.borderRadius.small};
      margin: 4px 0 4px 4px;
      user-select: none;
      text-transform: capitalize;
      font-weight: 500;
      cursor: pointer;
    }

    [cmdk-item] {
      content-visibility: auto;

      cursor: pointer;
      min-height: 48px;
      border-radius: ${({ theme }) => theme.borderRadius.large};
      font-size: 14px;
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 0 16px;
      color: ${({ theme }) => theme.colour.secondary.base};
      user-select: none;
      will-change: background, color;
      transition: all 150ms ease;
      transition-property: none;

      &[data-selected='true'] {
        background: ${({ theme }) => theme.colour.neutral.surface};
        color: ${({ theme }) => theme.colour.secondary.base};
      }

      &[data-disabled='true'] {
        color: ${({ theme }) => theme.colour.secondary._400};
        cursor: not-allowed;
      }

      &:active {
        transition-property: background;
        background: ${({ theme }) => theme.colour.neutral.surface};
      }

      & + [cmdk-item] {
        margin-top: 4px;
      }

      svg {
        width: 18px;
        height: 18px;
      }
    }

    [cmdk-list] {
      max-height: 400px;
      overflow: auto;
      overscroll-behavior: contain;
      transition: 100ms ease;
      transition-property: height;
    }

    [cmdk-vercel-shortcuts] {
      display: flex;
      margin-left: auto;
      gap: 8px;

      kbd {
        font-size: 12px;
        min-width: 20px;
        padding: 4px;
        height: 20px;
        border-radius: ${({ theme }) => theme.borderRadius.small};
        color: ${({ theme }) => theme.colour.secondary._600};
        background: ${({ theme }) => theme.colour.secondary._50};
        display: inline-flex;
        align-items: center;
        justify-content: center;
        text-transform: uppercase;
      }
    }

    [cmdk-separator] {
      height: 1px;
      width: 100%;
      background: ${({ theme }) => theme.colour.secondary._50};
      margin: 4px 0;
    }

    *:not([hidden]) + [cmdk-group] {
      margin-top: 8px;
    }

    [cmdk-group-heading] {
      user-select: none;
      font-size: 12px;
      color: ${({ theme }) => theme.colour.secondary._600};
      padding: 0 8px;
      display: flex;
      align-items: center;
      margin-bottom: 8px;
    }

    [cmdk-empty] {
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 48px;
      white-space: pre-wrap;
      color: ${({ theme }) => theme.colour.secondary._400};
    }
  }
`
